import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

//Controls
import ImageUpload from "Components/ImageUpload";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import { NotificationManager } from 'Components/Notifications';

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { Checkbox } from "@gpstrackit/react-controls";

//Styles
import "./index.scss";

//Actions
import {
    clearRedux,
    searchImageRequest,
    imagesOpenModal,
    uploadImageRequest,
} from 'Redux/actions';

let IMAGE = {
    name: "",
    type: "",
    file: null
}

const UploadImage = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const { editor } = props;

    const {
        openModal,
        imageList,
        loading,
        result,
    } = useSelector(state => state.cloudLoginPageUploadImageRedux);

    const [checkImage, setCheckImage] = useState(null)

    const [image, setImage] = useState(IMAGE)
    const [files, setFiles] = useState([]);
    const closeModal = () => {
        dispatch(imagesOpenModal(false));
        setImage(IMAGE);
        setFiles([]);
        setCheckImage(null);
    }

    const redoNum = (numero, digitos, sp = true) => {
        function toExp(numero, digitos) {
            let arr = numero.toString().split("e");
            let mantisa = arr[0], exponente = digitos;
            if (arr[1]) exponente = Number(arr[1]) + digitos;
            return Number(mantisa + "e" + exponente.toString());
        }
        let absNumero = Math.abs(numero);
        let signo = Math.sign(numero);
        if (sp) {
            let n = Math.floor(Math.log2(absNumero));
            let spacing = Math.pow(2, n) * Number.EPSILON;
            if (spacing < Math.pow(10, -digitos - 1)) {
                absNumero += spacing;
            }
        }
        let entero = Math.round(toExp(absNumero, digitos));
        return signo * toExp(entero, -digitos);
    }

    const addFile = (file) => {
        let currentImage = file ? file[0] : null

        if (currentImage) {
            let extensionImage = currentImage?.type.split("/")
            let nameImage = currentImage?.name?.split(".")
            setImage({
                name: nameImage[0],
                type: extensionImage[1],
                file: currentImage
            })
        }
    }

    const insertImage = () => {
        if (checkImage) {
            editor.current?.insertHTML(`<img style="width: 600px; height: 300px" src="${checkImage}"  />`, true);
            dispatch(searchImageRequest())
            closeModal();
        } else dispatch(uploadImageRequest(image))
    }

    useEffect(() => {
        openModal && imageList?.length === 0 && dispatch(searchImageRequest())
    }, [openModal])

    useEffect(() => {
        if (result) {
            if (result?.upload) {
                editor.current?.insertHTML(`<img style="width: 600px; height: 300px" src="${result?.url}"  />`, true);
                dispatch(searchImageRequest())
                closeModal();
            }
            dispatch(clearRedux("CLOUDLOGINPAGE_UPLOAD_IMAGE", { result: null }))
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['upload_image_title']}
            loading={loading}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    <p>{messages['upload_image_label']}</p>
                    <ImageUpload
                        files={files}
                        setFiles={(files) => {
                            if (files.length > 0) {
                                let size = files[0].size
                                let sizeInMB = (size / (1024 * 1024)).toFixed(2);
                                let mbValidation = redoNum(+sizeInMB, 1)
                                if (mbValidation > 10) {
                                    NotificationManager.warning(
                                        messages['upload_image_size_exceeds'],
                                        messages['upload_image_title'],
                                        3000
                                    );
                                    return
                                }
                            }
                            setFiles(files)
                        }}
                        addFile={addFile}
                    />
                    <div style={{ marginTop: 10, width: '100%' }}>
                        <ImageList sx={{ width: '100%', height: 450 }} cols={2} gap={8} style={{ height: '60vh' }}>
                            {imageList.map((item) => {
                                let name = item?.key.split('/')
                                name = name ? name[name.length - 1] : null
                                return (
                                    <ImageListItem key={item.url}>
                                        <img
                                            src={`${item.url}?w=248&fit=crop&auto=format`}
                                            srcSet={`${item.url}?w=248&fit=crop&auto=format&dpr=2 2x`}
                                            alt={item.key}
                                            loading="lazy"
                                        />
                                        <ImageListItemBar
                                            title={name || ''}
                                            subtitle={item.key}
                                            actionIcon={
                                                <Checkbox
                                                    id={item?.url}
                                                    value={item.url === checkImage}
                                                    onChange={(value) => {
                                                        let image = value ? item.url : null
                                                        setCheckImage(image)
                                                    }}
                                                />
                                            }
                                        />
                                    </ImageListItem>
                                )
                            })}
                        </ImageList>
                    </div>
                    <ImageList />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => insertImage()}
                    disabled={(!checkImage && files?.length == 0)}
                >
                    {messages['upload_image_insert']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default UploadImage;